import { FREQUENCY_ATTRIBUTE_ID } from "~/hec/telehealth/plan-selection";

/**
 * Recurring-price suffix for a treatment, or `null` when we can't prove the
 * cadence (ET-216).
 *
 * A single-SKU treatment has no `frequency` variation attribute at all and is
 * monthly by definition — that's every product in ET-216/217/218/219/220/221.
 * The two compounded masters DO carry `frequency` (`monthly` / `quarterly`, see
 * `hec/telehealth/plan-selection.ts`), and until ET-222/223 give them a real
 * plan selector there is no single cadence to name, so this returns `null` and
 * the price renders bare rather than claiming "/mo" for a 3-month plan.
 */
export function telehealthPricePeriod(product: {
  variationAttributes?: { id?: string; values?: unknown[] }[] | null;
  variants?: unknown[] | null;
}): string | null {
  const frequency = product.variationAttributes?.find(
    attr => attr?.id === FREQUENCY_ATTRIBUTE_ID,
  );
  if (!frequency) {
    // Only a genuinely variant-LESS treatment is monthly by definition. "Has
    // variants but no `frequency` attribute" is a real, separate catalog state
    // (`derivePlanOptions` in treatment-plan-selector.tsx handles it), and it's
    // also where a rename of the attribute id would land us — `freq` →
    // `frequency` already happened once (plan-selection.ts). Fail closed there
    // rather than asserting monthly for every plan.
    return (product.variants?.length ?? 0) > 0 ? null : "/mo";
  }
  return (frequency.values?.length ?? 0) === 1 ? "/mo" : null;
}
